import React, { Component } from 'react';
import { Table, THead, TH, TBody, TR, TD } from './styles';

class AxlTable extends Component {
  render () {
    return (<Table>
        {this.props.children}
    </Table>)
  }

  static Header = class extends Component {
    render () {
      return (<THead>{this.props.children}</THead>)
    }
  }
  static HeaderCell = class extends Component {
    constructor(props) {
      super(props)
    }

    render () {
      const props = {};
      if (this.props.onClick) {
        props.onClick = this.props.onClick;
      }
      return (<TH
        {...props}
        className={`${this.props.onClick ? 'pointer' : ''}${this.props.isActive ? ' active' : ''}${this.props.up ? ' up' : ''}`}><span>{this.props.children}</span></TH>)
    }
  }

  static Body = class extends Component {
    render () {
      return (<TBody>{this.props.children}</TBody>)
    }
  }

  static Row = class extends Component {
    render () {
      return (<TR>{this.props.children}</TR>)
    }
  }

  static Cell = class extends Component {
    render () {
      return (<TD {...this.props}>{this.props.children}</TD>)
    }
  }
}

export default AxlTable
